import { render, staticRenderFns } from "./erweimaActive.vue?vue&type=template&id=4fc9dffa&scoped=true&"
import script from "./erweimaActive.vue?vue&type=script&lang=js&"
export * from "./erweimaActive.vue?vue&type=script&lang=js&"
import style0 from "./erweimaActive.vue?vue&type=style&index=0&id=4fc9dffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9dffa",
  null
  
)

export default component.exports